// Pre-built iPhone image library for product catalog

// Dynamic imports for all phone images
import iphoneOriginal from "@/assets/phones/iphone-original.jpg";
import iphone3g from "@/assets/phones/iphone-3g.jpg";
import iphone4 from "@/assets/phones/iphone-4.jpg";
import iphone5 from "@/assets/phones/iphone-5.jpg";
import iphone6 from "@/assets/phones/iphone-6.jpg";
import iphone7 from "@/assets/phones/iphone-7.jpg";
import iphone8 from "@/assets/phones/iphone-8.jpg";
import iphoneX from "@/assets/phones/iphone-x.jpg";
import iphoneXr from "@/assets/phones/iphone-xr.jpg";
import iphoneXs from "@/assets/phones/iphone-xs.jpg";
import iphoneSe2 from "@/assets/phones/iphone-se-2.jpg";
import iphone11 from "@/assets/phones/iphone-11.jpg";
import iphone11Pro from "@/assets/phones/iphone-11-pro.jpg";
import iphone12Mini from "@/assets/phones/iphone-12-mini.jpg";
import iphone12 from "@/assets/phones/iphone-12.jpg";
import iphone12Pro from "@/assets/phones/iphone-12-pro.jpg";
import iphone13Mini from "@/assets/phones/iphone-13-mini.jpg";
import iphone13 from "@/assets/phones/iphone-13.jpg";
import iphone14 from "@/assets/phones/iphone-14.jpg";
import iphone14Pro from "@/assets/phones/iphone-14-pro.jpg";
import iphone15 from "@/assets/phones/iphone-15.jpg";
import iphone15Plus from "@/assets/phones/iphone-15-plus.jpg";
import iphone15Pro from "@/assets/phones/iphone-15-pro.jpg";
import iphone16 from "@/assets/phones/iphone-16.jpg";
import iphone16Pro from "@/assets/phones/iphone-16-pro.jpg";
import iphone17 from "@/assets/phones/iphone-17.jpg";
import iphone17Air from "@/assets/phones/iphone-17-air.jpg";
import iphone17Pro from "@/assets/phones/iphone-17-pro.jpg";
import iphone17ProMax from "@/assets/phones/iphone-17-pro-max.jpg";

export const iphoneImageLibrary = [
  { label: "iPhone 17 Pro Max", src: iphone17ProMax },
  { label: "iPhone 17 Pro", src: iphone17Pro },
  { label: "iPhone 17 Air", src: iphone17Air },
  { label: "iPhone 17", src: iphone17 },
  { label: "iPhone 16 Pro", src: iphone16Pro },
  { label: "iPhone 16", src: iphone16 },
  { label: "iPhone 15 Pro", src: iphone15Pro },
  { label: "iPhone 15 Plus", src: iphone15Plus },
  { label: "iPhone 15", src: iphone15 },
  { label: "iPhone 14 Pro", src: iphone14Pro },
  { label: "iPhone 14", src: iphone14 },
  { label: "iPhone 13 Mini", src: iphone13Mini },
  { label: "iPhone 13", src: iphone13 },
  { label: "iPhone 12 Pro", src: iphone12Pro },
  { label: "iPhone 12", src: iphone12 },
  { label: "iPhone 12 Mini", src: iphone12Mini },
  { label: "iPhone 11 Pro", src: iphone11Pro },
  { label: "iPhone 11", src: iphone11 },
  { label: "iPhone SE (2ª gen)", src: iphoneSe2 },
  { label: "iPhone XS", src: iphoneXs },
  { label: "iPhone XR", src: iphoneXr },
  { label: "iPhone X", src: iphoneX },
  { label: "iPhone 8", src: iphone8 },
  { label: "iPhone 7", src: iphone7 },
  { label: "iPhone 6", src: iphone6 },
  { label: "iPhone 5", src: iphone5 },
  { label: "iPhone 4", src: iphone4 },
  { label: "iPhone 3G", src: iphone3g },
  { label: "iPhone Original", src: iphoneOriginal },
];
